// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanTerminationPropertyDto
 */
export interface IPlanTerminationPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanTerminationPropertyDto
     */
    plan_id: number;
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertyDto
     */
    coverage_end_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertyDto
     */
    claim_last_date: Date;
    /**
     * 
     * @type {string}
     * @memberof IPlanTerminationPropertyDto
     */
    hsa_transfer_of_assets: IPlanTerminationPropertyDtoHsaTransferOfAssetsEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPlanTerminationPropertyDtoHsaTransferOfAssetsEnum {
    BULK_TRANSFER = 'BULK_TRANSFER',
    EMPLOYEE_OWNED = 'EMPLOYEE_OWNED',
    NOT_APPLICABLE = 'NOT_APPLICABLE'
}


/**
 * Check if a given object implements the IPlanTerminationPropertyDto interface.
 */
export function instanceOfIPlanTerminationPropertyDto(value: object): value is IPlanTerminationPropertyDto {
    if (!('plan_id' in value) || value['plan_id'] === undefined) return false;
    if (!('coverage_end_date' in value) || value['coverage_end_date'] === undefined) return false;
    if (!('claim_last_date' in value) || value['claim_last_date'] === undefined) return false;
    if (!('hsa_transfer_of_assets' in value) || value['hsa_transfer_of_assets'] === undefined) return false;
    return true;
}

export function IPlanTerminationPropertyDtoFromJSON(json: any): IPlanTerminationPropertyDto {
    return IPlanTerminationPropertyDtoFromJSONTyped(json, false);
}

export function IPlanTerminationPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanTerminationPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'],
        'coverage_end_date': (new Date(json['coverage_end_date'])),
        'claim_last_date': (new Date(json['claim_last_date'])),
        'hsa_transfer_of_assets': json['hsa_transfer_of_assets'],
    };
}

export function IPlanTerminationPropertyDtoToJSON(json: any): IPlanTerminationPropertyDto {
    return IPlanTerminationPropertyDtoToJSONTyped(json, false);
}

export function IPlanTerminationPropertyDtoToJSONTyped(value?: IPlanTerminationPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'coverage_end_date': ((value['coverage_end_date']).toISOString()),
        'claim_last_date': ((value['claim_last_date']).toISOString()),
        'hsa_transfer_of_assets': value['hsa_transfer_of_assets'],
    };
}

